import React from 'react';
import ulog from 'ulog';

import { CONSTANTS } from 'joy-joy';
import Axes from './right-axes';

const log = ulog('joy-con-left');

const {
  BUTTON_MAPPINGS,
  COLORS: { RED }
} = CONSTANTS;

const DEFAULT_COLOR = '#44484C';
const ACTIVE_COLOR = '#FCFCFC';

/**
 * JoyCon Right SVG
 *
 * Based off https://commons.wikimedia.org/wiki/File:Nintendo_Switch_Joy-Con_illustration.svg
 * Generated from https://github.com/smooth-code/svgr
 */
const JoyConRight = props => {
  const { index, buttons, axes } = props;
  log.info(
    `R#${index.toString()}`,
    buttons.map(({ value }) => value).join(' ')
  );

  const controllerColor = RED;

  const buttonColors = {};
  Object.keys(BUTTON_MAPPINGS).forEach(key => {
    const index = BUTTON_MAPPINGS[key];
    const button = buttons[index];
    const defaultColor = ['SL', 'SR'].includes(key)
      ? controllerColor
      : DEFAULT_COLOR;

    buttonColors[key] =
      !!button && button.pressed ? ACTIVE_COLOR : defaultColor;
  });

  return (
    <svg width={153} height={437} viewBox="0 0 153 437" fill="none" {...props}>
      <path
        d="M37 24.0904V4.96019C37 3.08634 38.2263 1.00008 39.5373 1.00008H77.0087C115.689 1.00008 137.915 49.6946 143.849 84.2562C144.119 85.8329 144.216 89.0001 142.455 89.0001H138.002L37 24.0904Z"
        fill={buttonColors.Z_TRIGGER}
        stroke="black"
      />
      <path
        d="M38.0324 19.8438V15.6562C38.0324 14.3994 39.3162 13 40.6887 13H66.9387C107.432 13 143.678 45.6619 149.89 68.8441C150.173 69.9017 150.275 72.0261 148.432 72.0261H143.769L38.0324 19.8438Z"
        fill={buttonColors.TRIGGER}
        stroke="black"
      />
      <path
        d="M2.54675 41.2448H16.5563V376.844H10.0012V390.781C10.0012 392.339 8.69302 394.966 7.58502 394.966H2.70428C1.80898 394.966 1.00244 394.275 1.00244 393.264V328.021C1.00244 319.402 6.39166 319.296 6.39166 316.574V281.97C6.39166 279.515 1.13257 278.911 1.13257 271.894V157.343C1.13257 150.388 6.39166 149.92 6.39166 147.267L6.26666 113.237C6.26666 110.893 1.00757 109.088 1.00757 102.851V43.0457C0.997568 42.064 1.48177 41.2448 2.54327 41.2448H2.54675Z"
        fill="#44484C"
        stroke="black"
      />
      <path
        d="M15.1887 21.9999V434.687C15.1887 435.711 15.6945 436.484 16.9855 436.484H66.6262C118.306 436.484 151.701 390.787 151.701 351.409V103.469C151.701 45.5836 94.9367 18.7498 66.9821 18.7498H18.1915C15.7054 18.7498 15.1887 20.1177 15.1887 21.9999V21.9999Z"
        fill={controllerColor}
        stroke="black"
      />
      <path
        d="M3.07709 112.928H7.27557V147.443H3.16547C1.72997 147.443 1 146.442 1 145.278V114.74C1 113.635 1.80849 112.928 3.07709 112.928Z"
        fill={buttonColors.SR}
        stroke="black"
      />
      <path
        d="M3.07709 316.693H7.27557V282.178H3.16547C1.72997 282.178 1 283.179 1 284.343V314.881C1 315.986 1.80849 316.693 3.07709 316.693Z"
        fill={buttonColors.SL}
        stroke="black"
      />
      <path
        d="M26.4684 56.4666H34.0761V48.9536H40.3896V56.4982H47.871V62.8116H40.4212V70.6088H34.0131V62.8116H26.4999L26.4684 56.4666Z"
        fill={buttonColors.PLUS}
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.0093 318.264C73.0093 322.727 71.2361 327.008 68.08 330.164C64.9238 333.32 60.6432 335.093 56.1798 335.093C51.7163 335.093 47.4357 333.32 44.2795 330.164C41.1234 327.008 39.3503 322.727 39.3503 318.264C39.3503 313.8 41.1234 309.52 44.2795 306.364C47.4357 303.207 51.7163 301.434 56.1798 301.434C60.6432 301.434 64.9238 303.207 68.08 306.364C71.2361 309.52 73.0093 313.8 73.0093 318.264Z"
        fill="#999595"
        stroke="black"
        strokeWidth={0.742744}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.7489 318.417C68.7489 321.75 67.4247 324.947 65.0675 327.305C62.7103 329.662 59.5133 330.986 56.1797 330.986C52.8461 330.986 49.6491 329.662 47.2919 327.305C44.9347 324.947 43.6104 321.75 43.6104 318.417C43.6104 315.083 44.9347 311.886 47.2919 309.529C49.6491 307.172 52.8461 305.848 56.1797 305.848C59.5133 305.848 62.7103 307.172 65.0675 309.529C67.4247 311.886 68.7489 315.083 68.7489 318.417Z"
        fill={buttonColors.HOME}
        stroke="black"
        strokeWidth={0.99449}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.3384 317.747H49.8223V325.565C53.9863 325.565 58.6396 325.565 62.4245 325.565V317.747H64.9083C62.1718 315.202 58.4889 311.727 56.1234 309.564C53.2605 312.195 50.243 315.035 47.3384 317.747V317.747ZM53.1951 317.878C55.1326 317.878 57.2956 317.878 59.0517 317.878V322.872C57.1162 322.872 54.9537 322.872 53.1951 322.872V317.878Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M94.0892 92.5059C94.0892 96.524 92.493 100.378 89.6517 103.219C86.8105 106.06 82.9569 107.656 78.9388 107.656C74.9207 107.656 71.0671 106.06 68.2258 103.219C65.3846 100.378 63.7884 96.524 63.7884 92.5059C63.7884 88.4877 65.3846 84.6342 68.2258 81.7929C71.0671 78.9517 74.9207 77.3555 78.9388 77.3555C82.9569 77.3555 86.8105 78.9517 89.6517 81.7929C92.493 84.6342 94.0892 88.4877 94.0892 92.5059Z"
        fill={buttonColors.X}
        stroke="black"
        strokeWidth={0.82506}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.6209 100.614C71.6209 100.603 72.8506 98.7186 74.3536 96.4238L77.0862 92.251L74.6644 88.5101C73.3324 86.4526 72.2119 84.7257 72.1746 84.6727L72.1066 84.5767H73.9808H75.8549L77.4617 87.1533C78.3455 88.5705 79.084 89.7247 79.1028 89.7184C79.1218 89.7074 79.8409 88.5566 80.7012 87.1506L82.2653 84.5941L84.1115 84.5831C85.1269 84.5721 85.9578 84.5831 85.9578 84.5941C85.9578 84.6051 84.8447 86.3502 83.4841 88.4744C82.068 90.6855 81.0167 92.3606 81.0251 92.3928C81.0351 92.4238 82.2568 94.2809 83.7442 96.52C85.2316 98.759 86.4485 100.6 86.4485 100.611C86.4485 100.622 85.585 100.63 84.5294 100.63H82.6102L80.8262 97.8423C79.3855 95.5906 79.0341 95.0631 78.9993 95.1006C78.9753 95.1256 78.1636 96.3813 77.1951 97.89L75.4341 100.633H73.5275C72.4788 100.633 71.6207 100.622 71.6207 100.616L71.6209 100.614Z"
        fill="#bbbbbb"
      />
      <path
        d="M110.253 138.971C106.235 138.971 102.382 137.375 99.5405 134.533C96.6993 131.692 95.1031 127.839 95.1031 123.821C95.1031 119.802 96.6993 115.949 99.5405 113.108C102.382 110.266 106.235 108.67 110.253 108.67C114.272 108.67 118.125 110.266 120.966 113.108C123.808 115.949 125.404 119.802 125.404 123.821C125.404 127.839 123.808 131.692 120.966 134.533C118.125 137.375 114.272 138.971 110.253 138.971Z"
        fill={buttonColors.A}
        stroke="black"
        strokeWidth={0.82506}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.589 131.693C102.649 131.533 108.655 116.115 108.731 115.924L108.818 115.705H110.51H112.201L115.398 123.686C117.156 128.075 118.603 131.686 118.613 131.711C118.627 131.746 118.277 131.753 116.885 131.745L115.14 131.735L114.437 129.904L113.734 128.073L110.511 128.083L107.287 128.093L106.623 129.924L105.958 131.755H104.262C102.661 131.755 102.567 131.745 102.589 131.694L102.589 131.693ZM112.692 125.368C112.682 125.344 112.182 123.995 111.578 122.37C110.975 120.746 110.471 119.429 110.459 119.444C110.442 119.464 109.152 122.992 108.294 125.368C108.281 125.402 108.736 125.411 110.493 125.411C112.251 125.411 112.705 125.401 112.692 125.368Z"
        fill="#bbbbbb"
      />
      <path
        d="M94.0892 155.135C94.0892 159.153 92.493 163.007 89.6517 165.848C86.8105 168.69 82.9569 170.286 78.9388 170.286C74.9207 170.286 71.0671 168.69 68.2258 165.848C65.3846 163.007 63.7884 159.153 63.7884 155.135C63.7884 151.117 65.3846 147.264 68.2258 144.422C71.0671 141.581 74.9207 139.985 78.9388 139.985C82.9569 139.985 86.8105 141.581 89.6517 144.422C92.493 147.264 94.0892 151.117 94.0892 155.135Z"
        fill={buttonColors.B}
        stroke="black"
        strokeWidth={0.82506}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.9946 155.48V147.47L76.9543 147.487C80.9022 147.504 81.3284 147.517 82.1201 147.637C83.3214 147.819 84.3075 148.433 84.9583 149.404C85.9477 150.879 85.788 152.804 84.569 154.096C84.2848 154.398 84.0125 154.609 83.6332 154.821L83.3388 154.986L83.5773 155.065C84.1588 155.257 84.7739 155.609 85.1868 155.987C85.6714 156.431 86.0888 157.135 86.2702 157.814C86.3532 158.124 86.3622 158.223 86.3652 158.805C86.3652 159.31 86.3541 159.515 86.3041 159.741C86.1021 160.66 85.6569 161.514 85.0659 162.116C84.3095 162.887 83.3817 163.278 82.0565 163.385C81.3964 163.438 78.1811 163.488 75.3806 163.489H72.9943V155.479L72.9946 155.48ZM80.9783 160.763C81.718 160.702 82.1124 160.551 82.5032 160.183C82.9073 159.801 83.0747 159.361 83.0734 158.683C83.0734 157.637 82.5053 156.905 81.5213 156.675C80.9514 156.541 80.6169 156.523 78.3878 156.507L76.2112 156.491V158.644V160.798H78.3878C79.5848 160.798 80.7505 160.782 80.9783 160.763V160.763ZM79.6901 153.842C80.8574 153.809 81.0912 153.775 81.512 153.576C81.9522 153.367 82.2623 153.02 82.4088 152.573C82.509 152.267 82.5088 151.643 82.4078 151.332C82.2191 150.749 81.786 150.373 81.1204 150.215C80.9128 150.166 80.5498 150.156 78.545 150.143L76.2111 150.129V152.003V153.876H77.4261C78.0944 153.876 79.1131 153.861 79.69 153.845L79.6901 153.842Z"
        fill="#bbbbbb"
      />
      <path
        d="M47.6239 138.971C43.6058 138.971 39.7522 137.375 36.911 134.533C34.0697 131.692 32.4735 127.839 32.4735 123.821C32.4735 119.802 34.0697 115.949 36.911 113.108C39.7522 110.266 43.6058 108.67 47.6239 108.67C51.6421 108.67 55.4956 110.266 58.3369 113.108C61.1781 115.949 62.7744 119.802 62.7744 123.821C62.7744 127.839 61.1781 131.692 58.3369 134.533C55.4956 137.375 51.6421 138.971 47.6239 138.971Z"
        fill={buttonColors.Y}
        stroke="black"
        strokeWidth={0.82506}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.0966 128.695V125.326L43.1837 120.72C41.5815 118.188 40.2706 116.109 40.2706 116.101C40.2706 116.091 41.1065 116.087 42.1282 116.087L43.986 116.087L45.8698 119.259C47.2709 121.618 47.7637 122.42 47.7923 122.39C47.8133 122.368 48.651 120.94 49.6534 119.218L51.4758 116.087H53.308H55.1403L55.0903 116.166C55.0623 116.209 53.7422 118.294 52.1558 120.8L49.2715 125.356V128.711V132.065H47.6841H46.0969V128.696L46.0966 128.695Z"
        fill="#bbbbbb"
      />
      <path
        d="M111.189 240.094C111.189 248.597 107.811 256.752 101.798 262.765C95.785 268.778 87.6298 272.156 79.1263 272.156C70.6228 272.156 62.4676 268.778 56.4547 262.765C50.4418 256.752 47.0638 248.597 47.0638 240.094C47.0638 231.59 50.4418 223.435 56.4547 217.422C62.4676 211.409 70.6228 208.031 79.1263 208.031C87.6298 208.031 95.785 211.409 101.798 217.422C107.811 223.435 111.189 231.59 111.189 240.094V240.094Z"
        fill="#44484C"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.61 240.316C101.61 246.279 99.2415 251.998 95.0249 256.215C90.8083 260.431 85.0894 262.8 79.1262 262.8C73.163 262.8 67.4441 260.431 63.2275 256.215C59.0109 251.998 56.642 246.279 56.642 240.316C56.642 234.353 59.0109 228.634 63.2275 224.417C67.4441 220.201 73.163 217.832 79.1262 217.832C85.0894 217.832 90.8083 220.201 95.0249 224.417C99.2415 228.634 101.61 234.353 101.61 240.316Z"
        fill={buttonColors.RIGHT_STICK}
        stroke="black"
        strokeWidth={1.426}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.9644 213.98C77.9646 211.835 77.9744 210.568 77.9804 210.5C78.0104 210.293 78.112 210.095 78.2696 209.938C78.7448 209.462 79.553 209.603 79.846 210.213C79.9558 210.441 79.9481 210.164 79.9484 213.93L79.9487 217.332L79.2473 217.332C78.8615 217.331 78.415 217.336 78.2551 217.342L77.9643 217.353L77.9645 213.98H77.9644Z"
        fill="black"
        stroke="black"
        strokeWidth={0.03125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.8448 270.401C78.4554 270.357 78.1201 270.068 77.9975 269.669C77.9735 269.59 77.9705 269.339 77.9665 266.43L77.9565 263.276L78.1873 263.289C78.3143 263.296 78.761 263.302 79.1801 263.302H79.942V266.458V269.614L79.9069 269.716C79.8025 270.021 79.5614 270.261 79.2557 270.363C79.1557 270.397 78.9663 270.414 78.8476 270.401L78.8448 270.401Z"
        fill="black"
        stroke="black"
        strokeWidth={0.03125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.111 240.384C102.111 240.029 102.101 239.583 102.098 239.391L102.085 239.044L105.316 239.047L108.548 239.052L108.662 239.093C109.094 239.251 109.361 239.648 109.332 240.087C109.316 240.331 109.221 240.545 109.051 240.718C108.919 240.854 108.794 240.926 108.563 241C108.513 241.016 107.852 241.021 105.306 241.024L102.11 241.029V240.384L102.111 240.384Z"
        fill="black"
        stroke="black"
        strokeWidth={0.03125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.439 241.012C49.2239 240.984 49.014 240.875 48.8609 240.713C48.3281 240.15 48.5969 239.251 49.3531 239.066C49.4241 239.049 50.0422 239.045 52.8029 239.044L56.1668 239.044L56.1547 239.376C56.1447 239.559 56.1428 240.005 56.1428 240.368V241.028L52.8381 241.026C51.0205 241.025 49.4911 241.018 49.4396 241.012H49.439Z"
        fill="black"
        stroke="black"
        strokeWidth={0.03125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Axes index={index} axes={axes} />
    </svg>
  );
};

export default JoyConRight;
